import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaInjector from '@/components/base/SchemaInjector';
import { organizationSchema, websiteSchema, getWebPageSchema, getFAQSchema } from '@/mocks/schema';
import { faqData } from '@/mocks/data';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import LiveChannels from './components/LiveChannels';
import FeaturedArticles from './components/FeaturedArticles';
import LatestContent from './components/LatestContent';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const webPageSchema = getWebPageSchema(
    'https://www.chuanmeizaixian.com/',
    '传媒在线观看·高清直播点播平台 - 首页',
    '传媒在线观看，汇聚海量高清视频资源，支持直播、点播、回看全场景体验。覆盖新闻、综艺、纪录片、影视剧等全品类内容。'
  );
  const faqSchema = getFAQSchema(faqData);

  return (
    <>
      <SchemaInjector schema={[organizationSchema, websiteSchema, webPageSchema, faqSchema]} />

      <main>
        <Navbar />
        <HeroSection />
        <CategoryGrid />
        <LiveChannels />
        <FeaturedArticles />
        <LatestContent />
        <FAQSection />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}